import { Routes, Route, Navigate } from "react-router-dom";
import { AdminAuthProvider, useAdminAuth } from "@/admin/AdminAuth";
import AdminLogin from "@/admin/AdminLogin";
import AdminLayout from "@/admin/AdminLayout";
import Dashboard from "@/admin/pages/Dashboard";
import Donations from "@/admin/pages/Donations";
import Donors from "@/admin/pages/Donors";
import Messages from "@/admin/pages/Messages";
import Projects from "@/admin/pages/Projects";
import Content from "@/admin/pages/Content";
import Media from "@/admin/pages/Media";
import Settings from "@/admin/pages/Settings";
import Payments from "@/admin/pages/Payments";
import AdminUsers from "@/admin/pages/AdminUsers";
import Activity from "@/admin/pages/Activity";

const Protected = ({ children }) => {
  const { user, loading } = useAdminAuth();
  if (loading || user === null) return <div className="min-h-screen flex items-center justify-center text-gray-400">Loading…</div>;
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
};

export default function AdminApp() {
  return (
    <AdminAuthProvider>
      <Routes>
        <Route path="login" element={<AdminLogin />} />
        <Route path="/" element={<Protected><AdminLayout /></Protected>}>
          <Route index element={<Dashboard />} />
          <Route path="donations" element={<Donations />} />
          <Route path="donors" element={<Donors />} />
          <Route path="messages" element={<Messages />} />
          <Route path="projects" element={<Projects />} />
          <Route path="content" element={<Content />} />
          <Route path="media" element={<Media />} />
          <Route path="settings" element={<Settings />} />
          <Route path="payments" element={<Payments />} />
          <Route path="users" element={<AdminUsers />} />
          <Route path="activity" element={<Activity />} />
        </Route>
      </Routes>
    </AdminAuthProvider>
  );
}
